import { type Ref, ref } from 'vue'

import type { ConfirmOptions } from '../typings/confirmOptions'
import { Confirm } from '../utils/confirm/confirm'

/**
 * Serwis potwierdzenia akcji
 *
 * @export
 * @class ModalService
 */
export class ConfirmService {
  /**
   * Oczekujące potwierdzenia
   *
   * @type {Ref<Confirm[]>}
   * @memberof ConfirmService
   */
  public pendingConfirms: Ref<Confirm[]> = ref([])

  /**
   * Proste potwierdzenie akcji
   *
   * @param {string} message
   * @param {(Record<string, string | number>)} [translateParameters]
   * @returns {Promise<boolean>}
   * @memberof ConfirmService
   */
  public confirm(
    message: string,
    translateParameters?: Record<string, string | number>,
  ): Promise<boolean> {
    return this.configurable(message, { translateParameters })
  }

  /**
   * Prosty dialog
   *
   * @param {string} message
   * @param {(Record<string, string | number>)} [translateParameters]
   * @returns {Promise<boolean>}
   * @memberof ConfirmService
   */
  public dialog(
    message: string,
    translateParameters?: Record<string, string | number>,
  ): Promise<boolean> {
    return this.configurable(message, {
      translateParameters,
      acceptButtonText: 'buttons.ok',
      hideRejectButton: true,
    })
  }

  /**
   * Potwierdzenie akcji z konfiguracją
   *
   * @param {string} message
   * @param {ConfirmOptions} [options]
   * @returns {Promise<boolean>}
   * @memberof ConfirmService
   */
  public configurable(message: string, options?: ConfirmOptions): Promise<boolean> {
    const currentConfirm = new Confirm(message, options)
    this.pendingConfirms.value.push(currentConfirm)
    return currentConfirm.result.finally(
      () =>
        (this.pendingConfirms.value = this.pendingConfirms.value.filter(
          (pendingConfirm) => pendingConfirm.id !== currentConfirm.id,
        )),
    )
  }
}

export const confirmService = new ConfirmService()
